/** @copyright (c) Viewpost. All Rights Reserved. See LICENSE for more details. */

export default {
  en: {}
};
